import React, {useEffect, useState} from 'react';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import logo from "../../assets/vmou.png";
import { PDFViewer } from "@react-pdf/renderer";
import {Page, Text, View, Document, StyleSheet, Image} from "@react-pdf/renderer";
//import {ToWords} from 'to-words';

const styles = StyleSheet.create({
    page: {
      margin: '10px 10px 10px 10px'
    },
    section: {
      margin: 5
    }
});
const Billstatement = (props) => {
    const history = useHistory();
    const [po,setpo] = useState(null);
    let pdfDoc = null;

    useEffect(() => {
        setpo(history.location.state.bills);
      },[history.location.state.bills]);

    const formatDate = (dt) => {
        let cdt = new Date(dt);
        let month = cdt.getMonth() + 1;
        let day = cdt.getDate();
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
        return day+"-"+month+"-"+cdt.getFullYear() ;
      };
    
    if (po) { 
        let tgross=0;
        let tswf=0;
        let ttds=0;
        let tnet=0;

        for (let i=0;i<po.length;i++) {
            tgross = tgross + po[i].gross;
            tswf = tswf + po[i].swf;
            ttds = ttds + po[i].tds;
            tnet = tnet + po[i].netamt;
        }
        //const toWords = new ToWords();
        pdfDoc = (<Document>
        <Page size="A4" style={{padding:'25px 5px 50px 20px'}} >
            <View fixed style={{margin:'0 10 0 20', display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
                <View style={styles.section}>
                    <Image src={logo} alt="vmou" style={{height:'50px', width:'40px'}}></Image>
                </View>
                <View style={{margin:'5', display:'flex',flexDirection:'col', alignItems: 'flex-end'}}>
                    <Text style={{fontSize:'12',fontStyle:'bold',  margin:'0'}}>Vardhman Mahaveer Open University, Kota</Text>
                    <Text style={{fontSize:'9', margin:'0'}}>Rawatbhata Road</Text>
                    <Text style={{fontSize:'9', margin:'0'}}>KOTA (RAJ.) 324021</Text>
                </View>
            </View>
            <Text fixed style={{textAlign:'center', fontSize:'10',fontStyle:'bold',  margin:'10 0 10 0'}}>Bill Statement - University Exam {po[0].exam} Coordinator:{po[0].userid.name}</Text>
            <View fixed style={{margin:'0 10 0 20', display:'flex', padding:'2px', flexDirection:'row', justifyContent:'space-between',  borderStyle:'solid', borderTopWidth:'1px', borderBottomWidth:'1px'}}>
                <Text style={{width:'6%',textAlign:'center', marginLeft:'5', fontSize:'10'}}>S.No</Text>
                <Text style={{width:'9%',textAlign:'center',marginLeft:'5', fontSize:'10'}}>Bill No</Text>
                <Text style={{width:'12%',textAlign:'center',marginLeft:'5', fontSize:'10'}}>Date</Text>
                <Text style={{width:'30%',textAlign:'left',marginLeft:'5', fontSize:'10'}}>Examiner</Text>
                <Text style={{width:'10%',textAlign:'right',marginLeft:'5', fontSize:'10'}}>Gross Amt</Text>
                <Text style={{width:'10%',textAlign:'right',marginLeft:'5', fontSize:'10'}}>S.W.F.</Text>
                <Text style={{width:'10%',textAlign:'right', marginLeft:'5', fontSize:'10'}}>T.D.S.</Text>
                <Text style={{width:'12%',textAlign:'right', marginRight:'5', fontSize:'10'}}>Net Amt</Text>
            </View>
            {po.map((i,k) => (
                <View key={k} style={{margin:'0 10 0 20', padding:'2px',display:'flex', flexDirection:'row', justifyContent:'space-between',  borderStyle:'solid', borderBottomWidth:'1px'}}>
                    <Text style={{width:'6%',textAlign:'center', marginLeft:'5', fontSize:'10'}}>{k+1}</Text>
                    <Text style={{width:'9%',textAlign:'center', marginLeft:'5', fontSize:'10'}}>{i.billno}</Text>
                    <Text style={{width:'12%',textAlign:'center', marginLeft:'5', fontSize:'10'}}>{formatDate(i.billdate)}</Text>
                    <Text style={{width:'30%',textAlign:'left',marginLeft:'5', fontSize:'10'}}>{i.examinerid.name}</Text>
                    <Text style={{width:'10%',textAlign:'right',marginLeft:'5', fontSize:'10'}}>{i.gross.toFixed(2)}</Text>
                    <Text style={{width:'10%',textAlign:'right',marginLeft:'5', fontSize:'10'}}>{i.swf.toFixed(2)}</Text>
                    <Text style={{width:'10%',textAlign:'right',marginLeft:'5', fontSize:'10'}}>{i.tds.toFixed(2)}</Text>
                    <Text style={{width:'12%',textAlign:'right',marginRight:'5',fontSize:'10'}}>{i.netamt.toFixed(2)}</Text>
                </View>
            ))}
            <View style={{margin:'0 10 0 20', display:'flex', padding:'2px', flexDirection:'row', justifyContent:'space-between',  borderStyle:'solid',  borderBottomWidth:'1px'}}>
                <Text style={{width:'57%',textAlign:'left',marginRight:'5', fontSize:'10'}}>T O T A L</Text>
                <Text style={{width:'10%',textAlign:'right',marginLeft:'31', fontSize:'10'}}>{tgross.toFixed(2)}</Text>
                <Text style={{width:'10%',textAlign:'right',marginLeft:'0', fontSize:'10'}}>{tswf.toFixed(2)}</Text>
                <Text style={{width:'10%',textAlign:'right',marginLeft:'0', fontSize:'10'}}>{ttds.toFixed(2)}</Text>
                <Text style={{width:'10%',textAlign:'right',marginRight:'0',fontSize:'10'}}>{tnet.toFixed(2)}</Text>
            </View>
            <Text style={{margin:'auto',position:'absolute',bottom:'10px', alignSelf:'center', fontSize:'10'}} render={({ pageNumber, totalPages }) => (
                `Page : ${pageNumber} / ${totalPages}`
            )} fixed />
        </Page>
    </Document>);
    }
    return (
        <PDFViewer style={{height:'100vh'}} width="100%" showToolbar={true}>
            {pdfDoc}
        </PDFViewer>
    );
};

const mapStateToProps = state => {
    return {
        username: state.auth.username,
        userid: state.auth.userid,
        email: state.auth.email,
        isAuth: state.auth.token !== null,
        }
}

export default connect(mapStateToProps)(Billstatement);